// extracted by mini-css-extract-plugin
export var background = "bx_x";
export var backgroundContainer = "bx_d8";
export var bottomWave = "bx_b5";
export var buttons = "bx_bC";
export var container = "bx_b";
export var content = "bx_bP";
export var icon = "bx_bz";
export var iconContainer = "bx_cX";
export var middleWave = "bx_b4";
export var negativeTop = "bx_g8";
export var overlap = "bx_hb";
export var section = "bx_j";
export var selected = "bx_bg";
export var tab = "bx_dF";
export var tabText = "bx_dD";
export var title = "bx_g";
export var topWave = "bx_g9";